import React from 'react';
import { usePWAStatus } from '../../hooks/usePWAStatus';
import { runtime } from '../../platform/runtime';
import AdaptiveNavigation from './AdaptiveNavigation';

export default function AdminNav({ showCaregiverPages = true }) {
    const { isPWA } = usePWAStatus();
    return <AdaptiveNavigation bottom={runtime.isNative() || isPWA} showCaregiverPages={showCaregiverPages} />;
}
